import { PageProps } from 'gatsby';
import React, { useMemo } from 'react';
import GlobalMain from 'molecules/Main/GlobalMain';
import getQueryParams from 'src/functions/getQueryParams';
import { TopInfoBarControllerProviderProps } from 'src/hooks/useTopInfoBarController';
import { ExtraQueryParamsProvider } from 'src/hooks/useExtraQueryParams';
import HeroBanner from 'sections/Homepage/HeroBanner/HeroBanner';
import BehindResults from 'sections/Homepage/BehindResults/BehindResults';
import Calculator from 'sections/Homepage/Calculator/Calculator';
import SellingRightNow from 'sections/Homepage/SellingRightNow/SellingRightNow';
import WhyMighty from 'sections/Homepage/WhyMighty/WhyMighty';
import NativeMobileApps from 'sections/Homepage/NativeMobileApps/NativeMobileApps';
import MightyProLink from 'sections/Homepage/MightyProLink/MightyProLink';
import CommunityDesign from 'sections/Homepage/CommunityDesign/CommunityDesign';
import PeopleMagicBlock from 'sections/Homepage/PeopleMagicBlock/PeopleMagicBlock';
import Testimonial from 'sections/Homepage/Testimonial/Testimonial';
import Receipts from 'sections/Homepage/Receipts/Receipts';
import TonyRobbinsArena from 'sections/Homepage/TonyRobbinsArena/TonyRobbinsArena';
import RealPeople from 'sections/Homepage/RealPeople/RealPeople';
import TheirOwnWords from 'sections/Homepage/TheirOwnWords/TheirOwnWords';
import PlansEveryStage from 'sections/Homepage/PlansEveryStage/PlansEveryStage';
import YourQuestionsAnswered from 'sections/Homepage/YourQuestionsAnswered/YourQuestionsAnswered';
import GettingStarted from 'sections/Homepage/GettingStarted/GettingStarted';
import YourTime from 'sections/Homepage/YourTime/YourTime';
import MakingTheSwitch from 'sections/Homepage/MakingTheSwitch/MakingTheSwitch';
import FreeTrialBlock from 'sections/Homepage/FreeTrialBlock/FreeTrialBlock';

const HomepageView = (props: PageProps): JSX.Element => {
  const infoBarProps = useMemo<Omit<TopInfoBarControllerProviderProps, 'children'> | false | undefined>(() => {
    if (getQueryParams()['inactive_network'] === '1') {
      return {
        visible: true,
        dismissible: true,
        contentLayout: 'inactiveNetworks',
      };
    }

    return undefined;
  }, []);

  return (
    <ExtraQueryParamsProvider extraQueryParams={{ from_community_design: '1' }}>
      <GlobalMain
        location={props.location}
        infoBarProps={infoBarProps}
      >
        <HeroBanner />
        <BehindResults />
        <Calculator />
        <SellingRightNow />
        <WhyMighty />
        <NativeMobileApps />
        <MightyProLink />
        <CommunityDesign />
        <PeopleMagicBlock />
        <Testimonial />
        <Receipts />
        <TonyRobbinsArena />
        <RealPeople />
        <TheirOwnWords />
        <PlansEveryStage />
        <YourQuestionsAnswered />
        <GettingStarted />
        <YourTime />
        <MakingTheSwitch />
        <FreeTrialBlock />
      </GlobalMain>
    </ExtraQueryParamsProvider>
  );
};

export default HomepageView;
